// src/components/NavMenu.js

import { useState, useEffect } from '@wordpress/element';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { Topbar, Badge, Button } from '@bsf/force-ui';
import { CircleHelp } from 'lucide-react';
import { SureMailIcon } from 'assets/icons';
import { cn } from '@utils/utils';

const NavMenu = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const version = window.bseDataObject?.version || '1.0.0';
	// Define navigation items
	const navItems = [
		{ name: 'Dashboard', path: '/dashboard' },
		{ name: 'Settings', path: '/settings' },
		{ name: 'Connections', path: '/connections' },
		{ name: 'Email Logs', path: '/logs' },
		{ name: 'Notifications', path: '/notifications', comingSoon: true },
	];

	// Get the current active path
	const [ activePath, setActivePath ] = useState( location.pathname );

	// Update activePath when the location changes
	useEffect( () => {
		setActivePath( location.pathname );
	}, [ location.pathname ] );

	const handleIconClick = () => {
		navigate( '/dashboard' );
	};

	return (
		<>
			<Topbar className="relative shadow-sm bg-background-primary h-16 z-[1] p-0 gap-0">
				{ /* Left Section: Logo */ }
				<Topbar.Left>
					<Topbar.Item>
						<div
							onClick={ handleIconClick }
							className="flex items-center justify-center w-16 h-16 p-5 cursor-pointer"
						>
							<SureMailIcon />
						</div>
					</Topbar.Item>
				</Topbar.Left>

				{ /* Middle Section: Navigation */ }
				<Topbar.Middle className="h-full" align="left" gap="xs">
					<Topbar.Item className="h-full">
						<nav className="h-full space-x-4">
							{ navItems.map( ( item ) =>
								item.comingSoon ? (
									<span
										key={ item.name }
										className={ cn(
											'inline-flex items-center relative h-full content-center px-1 text-sm text-text-disabled font-medium bg-transparent cursor-not-allowed opacity-50',
											activePath.trim() === item.path
												? 'text-text-primary'
												: ''
										) }
									>
										{ item.name }
										<Badge
											label="Coming Soon"
											size="xs"
											variant="blue"
											className="pl-1 pr-1 ml-1"
										/>
									</span>
								) : (
									<Link
										key={ item.name }
										to={ item.path }
										className={ cn(
											'inline-block relative h-full content-center px-1 text-sm text-text-secondary font-medium no-underline bg-transparent focus:outline-none shadow-none border-1 hover:text-text-primary transition-colors duration-300',
											activePath.trim() === item.path
												? 'text-text-primary border-none after:content-[""] after:absolute after:bottom-0 after:inset-x-0 after:h-px after:bg-brand-primary-600 after:transition-all after:duration-300'
												: ''
										) }
									>
										{ item.name }
									</Link>
								)
							) }
						</nav>
					</Topbar.Item>
				</Topbar.Middle>

				{ /* Right Section: Version Badge and Icons */ }
				<Topbar.Right className="p-5">
					<Topbar.Item>
						<Badge
							label={ `V ${ version }` }
							size="xs"
							variant="neutral"
						/>
					</Topbar.Item>
					<Topbar.Item className="gap-2">
						<Button
							variant="ghost"
							size="xs"
							icon={ <CircleHelp /> }
							onClick={ () =>
								window.open(
									'https://suremails.com/docs/',
									'_blank'
								)
							}
							href=""
						/>
						{ /** TODO: What's New Integration */ }
						{ /* <Button
							variant="ghost"
							size="xs"
							icon={ <Megaphone /> }
						/> */ }
					</Topbar.Item>
				</Topbar.Right>
			</Topbar>
		</>
	);
};

export default NavMenu;
